import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const LoadingBall = (props) => {
  const {
    className,
    prefix = "",
    size = "large",
    color = "emphasised",
    ...otherProps
  } = props;
  const baseClass = `${prefix}loading__ball`;
  const loadingBallClass = cx(
    baseClass,
    `${baseClass}--${size}`,
    `${baseClass}--${color}`,
    className
  );
  return /* @__PURE__ */ jsx("span", { ...otherProps, className: loadingBallClass, "aria-hidden": true });
};
var LoadingBall_default = LoadingBall;
export {
  LoadingBall_default as default
};
